import { render, staticRenderFns } from "./ViewIndicatorsAppeals.vue?vue&type=template&id=40999a45&scoped=true"
import script from "./ViewIndicatorsAppeals.vue?vue&type=script&lang=js"
export * from "./ViewIndicatorsAppeals.vue?vue&type=script&lang=js"
import style0 from "./ViewIndicatorsAppeals.vue?vue&type=style&index=0&id=40999a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40999a45",
  null
  
)

export default component.exports